<template>
  <modal id="importParentCompanyValues" v-cloak>
    <div slot="title">
      <h3>Selecteer over te nemen informatie van {{parentCompany.name}}</h3>
    </div>
    <div slot="body">
      <div class="col-12 pb-3 text-left">
        <div>
          <input class="form-check-input" type="checkbox" v-model="checkboxValues.vat">
          <label> BTW-nummer: </label>
        </div>
          <div>
            <p>{{parentCompany.vat}}</p>
          </div>
      </div>
      <div class="col-12 pb-3 text-left">
        <div>
          <input class="form-check-input" type="checkbox" v-model="checkboxValues.supervisor" >
          <label> Supervisor: </label>
        </div>
        <div>
          <p>{{parentCompany.supervisor.name}}</p>
          <p>{{parentCompany.supervisor.email}}</p>
        </div>
      </div>
      <div class="col-12 pb-3 text-left">
        <div>
          <input class="form-check-input" type="checkbox" v-model="checkboxValues.standardHours" >
          <label> Standaard starturen: </label>
        </div>
        <div>
          <p>Startuur dag: {{parentCompany.customerHours.morning}}</p>
          <p>Startuur avond: {{parentCompany.customerHours.evening}}</p>
          <p>Startuur nacht: {{parentCompany.customerHours.night}}</p>
        </div>
      </div>
      <div class="col-12 pb-3 text-left">
        <div>
          <input class="form-check-input" type="checkbox" v-model="checkboxValues.invoiceAddress">
          <label>  Factureeradres: </label>
        </div>
        <div>
          <p>{{parentCompany.customerInvoiceAddress.street}} {{parentCompany.customerInvoiceAddress.houseNumber}}</p>
          <p>{{parentCompany.customerInvoiceAddress.postalCode}} {{parentCompany.customerInvoiceAddress.city}}</p>
        </div>
      </div>
      <div class="col-12 pb-3 text-left">
        <div>
          <input class="form-check-input" type="checkbox" v-model="checkboxValues.organisation" >
          <label> Naam die op de factuur vermeld moet worden: </label>
        </div>
        <div>
          <p>Naam van de organisatie: {{parentCompany.invoiceAddressingDto.organisationName}}</p>
          <p>Naam van de geadresseerde: {{parentCompany.invoiceAddressingDto.financialSupervisorReference}}</p>
          <p>E-mail(s) geadresseerde factuur: </p>
          <ul v-if="parentCompany.confirmedEmailDtos.length > 0">
            <li v-for="confirmedEmailDto in parentCompany.confirmedEmailDtos" :key="confirmedEmailDto.emailAddress">
              {{confirmedEmailDto.emailAddress}}
            </li>
          </ul>
          <u v-else>geen</u>
        </div>
      </div>
      <div class="col-12 pb-3 text-left">
        <div>
          <input class="form-check-input" type="checkbox" v-model="checkboxValues.paymentTerm">
          <label>  Betalingstermijn: </label>
        </div>
        <div>
          <p>{{parentCompany.paymentTerm}}</p>
        </div>
      </div>
      <div class="col-12 pb-3 text-left">
        <div>
          <input class="form-check-input" type="checkbox" v-model="checkboxValues.bonusRate" >
          <label> Bonus tarieven: </label>
        </div>
        <div>
          <ul v-if="parentCompany.bonusRateDtos.length > 0">
            <li v-for="bonusRateDto in parentCompany.bonusRateDtos" :key="bonusRateDto.bonusType">
              {{ bonusRateDto.bonusType }}: {{bonusRateDto.percentage}}%
            </li>
          </ul>
          <u v-else>geen</u>
        </div>
      </div>
    </div>
    <div slot="footer" class="col-md-12 text-center">
      <button
          class="btn-basic btn-fill-pulse"
          @click="validateChoices">
        Bevestigen
      </button>
    </div>
  </modal>
</template>
<script>

export default {
  props: ['parentCompany'],
  data: () => ({
    checkboxValues: {
      vat: false,
      invoiceAddress: false,
      organisation: false,
      bonusRate: false,
      standardHours :false,
      paymentTerm: false,
      supervisor: false
    }
  }),
  methods: {
    validateChoices() {
      this.$emit('update-chosen-fields', this.checkboxValues, this.parentCompany);
      this.$emit('close');
    },
  }
};
</script>

<style scoped>
label {
  font-weight: bold;
}
</style>